import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSeikyuUtiwakeListInfo,
  TNinusiSeikyuInfoGetRes,
  TNinusiSeikyuListGetReq,
  TNinusiSeikyuRegisterPostReq,
  TNinusiSeikyuUtiwakePutReq,
  TNinusiSeikyuListGetRes,
  TNinusiSeikyuUtiwakeListGetReq,
  TNinusiSeikyuRegisterPostRes,
  TNinusiSeikyuUpdatePutRes,
  TNinusiSeikyuUpdatePutReq,
  TNinusiSeikyuHaisiPostReq,
} from "./TNinusiSeikyu"

/**
 * 荷主マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class NinusiSeikyuService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TNinusiSeikyuListGetReq} params
   * @memberof NinusiSeikyuService
   */
  getList = async (params: TNinusiSeikyuListGetReq, signal?: AbortSignal) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TNinusiSeikyuListGetRes[]>> =
        await this.postInner(
          `/master/ninusiseikyu/actions/getlist`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得（請求内訳）
   *
   * @param {TNinusiSeikyuListGetReq} params
   * @memberof NinusiSeikyuService
   */
  getListUchiwake = async (
    params: TNinusiSeikyuUtiwakeListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TSeikyuUtiwakeListInfo[]>> =
        await this.postInner(
          `/master/ninusiseikyu/utiwake/actions/getlist`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新（請求内訳）
   * @param data
   */
  putUtiwake = async (data: TNinusiSeikyuUtiwakePutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<TSeikyuUtiwakeListInfo[]>> =
        await this.putInner(`/master/ninusiseikyu/utiwake`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {id} params
   * @returns TNinusiSeikyuInfoGetRes
   * @memberof NinusiSeikyuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TNinusiSeikyuInfoGetRes>> =
        await this.getInner(`/master/ninusiseikyu/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体登録
   *
   * @param {TNinusiSeikyuRegisterPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof NinusiSeikyuService
   */
  post = async (data: TNinusiSeikyuRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TNinusiSeikyuRegisterPostRes>> =
        await this.postInner(`master/ninusiseikyu/`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {id} params
   * @param {TNinusiSeikyuUpdatePutReq} data
   * @memberof NinusiSeikyuService
   */
  put = async (id: number, data: TNinusiSeikyuUpdatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TNinusiSeikyuUpdatePutRes>> =
        await this.putInner(`master/ninusiseikyu/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 廃止日登録
   * @param id
   * @param data
   * @returns
   */
  haisi = async (id: number, data: TNinusiSeikyuHaisiPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/ninusiseikyu/${id}/haisi`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 廃止日解除
   * @param id
   * @param data
   * @returns
   */
  haisiKaizyo = async (id: number, data: TNinusiSeikyuHaisiPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/ninusiseikyu/${id}/haisi/delete`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
